import { Grid, Box, makeStyles } from "@material-ui/core";
// import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
const useStyles = makeStyles((theme) => ({
  height100: {
    height: "100%",
    marginTop: 0,
  },
  avatar: {
    width: "200px",
    height: "200px",
    fontSize: 50,
    color: "orange",
    borderWidth: 10,
    backgroundColor: "white",
  },
  avatarBorder: {
    marginTop: 20,
    justifyContent: "center",
    display: "flex",
    width: "200px",
    height: "200px",
    alignItem: "center",
  },
}));
const RightGridCreate = ({ showAvatar = true }) => {
  const classes = useStyles();
  return (
    <Grid item xs={4} style={{ height: "100%" }}>
      <Box style={{ height: "100%" }}>
        <Box
          style={{
            height: "100%",
            backgroundColor: "#ffe9d6",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingTop: 20,
            boxSizing: "border-box",
          }}
          classes={{ main: classes.height100 }}
        >
          {/* {showAvatar ? (
            <Box
              borderColor="orange"
              border={5}
              borderRadius="50%"
              className={classes.avatarBorder}
            >
              <Avatar className={classes.avatar}>
                <AddCircleOutlineIcon style={{ width: 200, height: 200 }} />
              </Avatar>
            </Box>
          ) : null} */}
        </Box>
      </Box>
    </Grid>
  );
};

export default RightGridCreate;
